import React from 'react'
import styled from 'styled-components'
import Titulo from './Titulo'
import { valores } from '../listas/valores'
import { BOTONES } from '../constantes/enums.ts'
import Ficha from './ficha.jsx'
import { COLOR_TYPES } from '../constantes/colores.ts'

const Valores = () => {
    return (
        <Section>
            <Titulo color='var(--primary)' titulo='Valores' />
            <Container>
                {valores.map((element) => {
                    return <Ficha key={element.valor} color={COLOR_TYPES.PRIMARY} tipo={BOTONES.INFO} titulo={element.valor} texto={element.descripcion} icono={element.icono} />
                })}
            </Container>
        </Section>
    )
}

const Section = styled.section`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 80%;
    gap: 20px;
    transform: translateX(10%);
`
const Container = styled.article`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
    gap: 50px;
`
export default Valores